import * as React from "react";
import { Checkbox, ListGroupItem } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ComponentEx } from "../../../controls/ComponentEx";
import { Icon, tooltip } from "../../../controls/api";
import * as selectors from "../../../util/selectors";
import { setFBLoadOrder, setFBLoadOrderEntry } from "../actions/loadOrder";
import { LoadOrderIndexInput } from "./loadOrderIndex";
import { currentLoadOrderForProfile, currentModStateForProfile, } from "../selectors";
class ItemRenderer extends ComponentEx {
    render() {
        const item = Array.isArray(this.props.item)
            ? this.props.item[0].loEntry
            : this.props.item.loEntry;
        const displayCheckboxes = this.props.item.displayCheckboxes ?? false;
        return this.renderDraggable(item, displayCheckboxes);
    }
    renderValidationError() {
        const { invalidEntries, loEntry } = this.props.item;
        const invalidEntry = invalidEntries !== undefined
            ? invalidEntries.find((inv) => inv.id.toLowerCase() === loEntry.id.toLowerCase())
            : undefined;
        return invalidEntry !== undefined ? (React.createElement(tooltip.Icon, { className: "fblo-invalid-entry", name: "feedback-error", tooltip: invalidEntry.reason })) : null;
    }
    renderExternalBanner(item) {
        const { t } = this.props;
        return this.isExternal(item) ? (React.createElement("div", { className: "load-order-unmanaged-banner" },
            React.createElement(Icon, { className: "external-caution-logo", name: "feedback-warning" }),
            React.createElement("span", { className: "external-text-area" }, t("Not managed by Vortex")))) : null;
    }
    renderDraggable(item, displayCheckboxes) {
        const { loadOrder, className } = this.props;
        const key = !!item.name ? `${item.name}` : `${item.id}`;
        let classes = ["load-order-entry"];
        if (className !== undefined) {
            classes = classes.concat(className.split(" "));
        }
        if (this.isExternal(item)) {
            classes = classes.concat("external");
        }
        const checkBox = () => displayCheckboxes ? (React.createElement(Checkbox, { className: "entry-checkbox", checked: item.enabled, disabled: this.isLocked(item), onChange: this.onStatusChange })) : null;
        const lock = () => this.isLocked(item) ? (React.createElement(Icon, { className: "locked-entry-logo", name: "locked" })) : null;
        return (React.createElement(ListGroupItem, { key: key, className: classes.join(" "), ref: this.props.item.setRef },
            React.createElement(Icon, { className: "drag-handle-icon", name: "drag-handle" }),
            React.createElement(LoadOrderIndexInput, { className: "load-order-index", api: this.context.api, item: item, currentPosition: this.currentPosition(), lockedEntriesCount: this.lockedEntriesCount(), loadOrder: loadOrder, isLocked: this.isLocked, onApplyIndex: this.onApplyIndex }),
            this.renderValidationError(),
            React.createElement("p", { className: "load-order-name" }, key),
            this.renderExternalBanner(item),
            checkBox(),
            lock()));
    }
    isLocked(item) {
        return [true, "true", "always"].includes(item.locked);
    }
    isExternal(item) {
        return item.modId !== undefined ? false : true;
    }
    onStatusChange = (evt) => {
        const { item, onSetLoadOrderEntry, profile } = this.props;
        const entry = {
            ...item.loEntry,
            enabled: evt.target.checked,
        };
        onSetLoadOrderEntry(profile.id, entry);
    };
    currentPosition = () => {
        const { item, loadOrder } = this.props;
        return loadOrder.findIndex((entry) => entry.id === item.loEntry.id) + 1;
    };
    onApplyIndex = (idx) => {
        const { item, onSetLoadOrder, profile, loadOrder } = this.props;
        const currentIdx = this.currentPosition();
        if (currentIdx === idx) {
            return;
        }
        const entry = {
            ...item.loEntry,
            index: idx,
        };
        const newLO = loadOrder.filter((entry) => entry.id !== item.loEntry.id);
        newLO.splice(idx - 1, 0, entry);
        onSetLoadOrder(profile.id, newLO);
    };
    lockedEntriesCount = () => {
        const { loadOrder } = this.props;
        const locked = loadOrder.filter((item) => this.isLocked(item));
        return locked.length;
    };
}
function mapStateToProps(state, ownProps) {
    const profile = selectors.activeProfile(state);
    return {
        profile: profile,
        loadOrder: currentLoadOrderForProfile(state, profile.id),
        modState: currentModStateForProfile(state, profile.id),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetLoadOrderEntry: (profileId, entry) => dispatch(setFBLoadOrderEntry(profileId, entry)),
        onSetLoadOrder: (profileId, loadOrder) => dispatch(setFBLoadOrder(profileId, loadOrder)),
    };
}
export default withTranslation(["common"])(connect(mapStateToProps, mapDispatchToProps)(ItemRenderer));
